import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from 'components/App';

document.addEventListener('DOMContentLoaded', () => {
  const mainContentElement = document.getElementById('main-content');
  if (!mainContentElement) return;

  render(
    <BrowserRouter>
      <App />
    </BrowserRouter>,
    mainContentElement,
  );
});
